import callApi from "../../services/api";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AlertState } from "../GlobalStates/AlertState";
import { useRecoilState } from "recoil";

export const ValidateUserProfile = () => {
  const navigate = useNavigate();
  const [_,setAlertMessage] = useRecoilState(AlertState)

  useEffect(() => {
    const validateProfile = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const response = await callApi(
          "/doctors/profile-status",
          "GET",
          null,
          false,
          true,
          null
        );

        if (response.status === 200) {
          if (!response.body) {
            setAlertMessage("Please Complete your profile in order to proceed");
            navigate("/onboarding");
          }
        } else {
          console.log("Error");
        }
      }
    };

    validateProfile();
  }, [navigate]);

  return null;
};
